<div class="astral-auth-shell">
  <main class="astral-auth-panel">
    <header class="astral-auth-header">
      <div class="astral-auth-branding">
        <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
        <span class="astral-auth-branding__divider" aria-hidden="true"></span>
        <span class="astral-auth-branding__name">DinHyresvärd</span>
      </div>
      <app-language class="astral-auth-language" [orientation]="2"></app-language>
    </header>

    <section class="astral-auth-content">
      @if (form) {
        <astral-form
          class="astral-auth-form"
          [form]="form"
          [columns]="1"
          [mobileColumns]="1"
          autocomplete="on"
          (formSubmit)="onSubmit()"
        >
          <h1 class="astral-auth-title">{{ 'RESET_PASSWORD_FORM.HEADER' | translate }}</h1>
          <astral-input
            [control]="form.controls['password']"
            type="password"
            inputName="new-password"
            autocomplete="new-password"
            [doNotDisplayClear]="true"
          ></astral-input>
          <astral-input
            [control]="form.controls['confirmPassword']"
            type="password"
            inputName="confirm-password"
            autocomplete="new-password"
            [doNotDisplayClear]="true"
          ></astral-input>
          <div class="astral-form-actions astral-form-actions--start">
            <astral-button type="submit" variant="primary" labelKey="RESET_PASSWORD_FORM.SUBMIT_BTN"></astral-button>
          </div>
        </astral-form>
      }
    </section>
  </main>
</div>
